import React, { useState } from 'react'
import { DatePicker } from 'antd';

import "./DateRangePicker.scss"

type DateRangePickerProps = {
    startPlaceHolder: string;
    endPlaceHolder: string;
    onChange: (startDate: Date, endDate: Date) => void;
}

function DateRangePicker(props: DateRangePickerProps) {

    const { RangePicker } = DatePicker;

    return (
        <RangePicker placeholder={[props.startPlaceHolder, props.endPlaceHolder]} format={"DD-MM-YYYY"}
            onChange={(data: any) => { props.onChange(data[0].$d, data[1].$d); }} />
    )
}

export default DateRangePicker